import { render, staticRenderFns } from "./walmart.vue?vue&type=template&id=bee5c402&scoped=true&"
import script from "./walmart.vue?vue&type=script&lang=ts&"
export * from "./walmart.vue?vue&type=script&lang=ts&"
import style0 from "./walmart.vue?vue&type=style&index=0&id=bee5c402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee5c402",
  null
  
)

export default component.exports